import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'fcp-list-news',
  templateUrl: './list-news.component.html',
  styleUrls: ['./list-news.component.scss']
})
export class ListNewsComponent implements OnInit {
  @Input() public news: any;
  @Input() public page: number;
  @Input() public totalItems: number;
  @Output() public clickedPage: EventEmitter<any> = new EventEmitter();

  public hasPagination: boolean;

  public config = {
    id: 'custom',
    itemsPerPage: 12,
    currentPage: 1,
    totalItems: 1
  };

  ngOnInit() {
    this.config.currentPage = this.page;
    if (this.totalItems > this.config.itemsPerPage) {
      this.config.totalItems = this.totalItems;
      this.hasPagination = true;
    }
  }

  public changePage(page) {
    this.clickedPage.emit(page);
    this.config.currentPage = page;
  }
}
